import { FC, PropsWithChildren } from "react";
import { ContentProps } from "./content.types";
import clsx from "clsx";

import classes from './content.module.css';


const Content: FC<PropsWithChildren<ContentProps>> = ({ children, className }) => {
    return <div className={clsx(classes.content, className)}>{children}</div>;
}

export { Content };